<template>
    <el-cascader
        :placeholder="placeholder ? placeholder : $t('zhiji.overview.allChannel')"
        :options="channelOptions"
        v-model="initValue"
        :props="{ expandTrigger: 'hover', checkStrictly: true }"
        @change="onChange"
    />
</template>

<script>
/**
 * 所有游戏渠道改成接口获取，以下页面共用
 *
    1、数据总览-机器人-提问渠道
    2、数据分析-机器人热点分析-提问渠道
    3、数据分析-机器人满意度-提问渠道
    4、数据分析-机器人问答日志-提问渠道
    5、实时监控-机器人监控-提问渠道
    6、FAQ库—问题聚类管理：常规闭环
*/
import { setChannelData } from "./channelData.js";

export default {
    name: "ChannelSelect",
    data() {
        return {
            robotOptions: [],
            initValue: [this.value]
        };
    },
    props: {
        value: [Number, String],
        moreChannels: {
            type: Array,
            default: null
        },
        placeholder: {
            type: String,
            default: null
        }
    },
    model: {
        prop: "value",
        event: "change"
    },
    computed: {
        channelOptions() {
            const channels = this.robotOptions.slice(0);
            this.moreChannels && channels.push(...this.moreChannels);
            return channels;
        }
    },
    mounted() {
        this.getChannelData();
    },
    watch: {
        "$i18n.locale"() {
            this.getChannelData();
        }
    },
    methods: {
        async getChannelData() {
            await this.zhiji.requestByServiceName("getAllChannelData").then(result => {
                const robots = this.$store.state.zhiji.gameState.robots;
                this.robotOptions = setChannelData(result.list, robots);
            });
        },
        onChange(value) {
            const result = value[value.length - 1];
            this.$emit("change", result);
        }
    }
};
</script>
